import script from "./main.vue?vue&type=script&setup=true&lang=ts"
export * from "./main.vue?vue&type=script&setup=true&lang=ts"

import "./main.vue?vue&type=style&index=0&id=0a48f2fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a48f2fe"]])

export default __exports__